// TODO: Replace with functionality from VDP
import IsServerSideRendering from '../../utilities/IsServerSideRendering';

interface OpenModalPayloadDetails {
  callerIdentifier: string;
  modalTitle: string;
  onSuccess: () => void;
}

interface OpenModalPayload {
  bubbles: boolean;
  detail: OpenModalPayloadDetails;
}

const baseEventTags = 'header|account-modal';
const createHeaderEvent = (tags: string, payload?: OpenModalPayload) => {
  if (IsServerSideRendering) {
    return null;
  }
  const event = new CustomEvent(`${baseEventTags + tags}`, payload);

  return event;
};

let $element: HTMLElement | null = null;

// adding observer for /cars?login because event entry point isn't in the DOM when
// HeaderAccountModal.js attempts to open the modal
const listenForEntryAddedToDOM = () => {
  const observer = new MutationObserver((mutationList, innerObserver) => {
    for (const mutation of mutationList) {
      const eventEntryPoint = document.getElementById('header-plugin-events');
      if (mutation.addedNodes[0]?.isSameNode(eventEntryPoint)) {
        $element = eventEntryPoint;
        innerObserver.disconnect();
      }
    }
  });

  const headerEl = document.getElementById('mfer-HeaderModule-default');

  if (headerEl) {
    observer.observe(headerEl, {
      childList: true,
      attributes: false,
      subtree: false
    });
  }
};

const getHeaderEventEntry = () => {
  if (!$element && !IsServerSideRendering) {
    const eventEntryPoint = document.getElementById('header-plugin-events');
    if (!eventEntryPoint) listenForEntryAddedToDOM();

    return eventEntryPoint;
  }

  return $element;
};

const handleHeaderEvents = (headerEvent: CustomEvent | null): void => {
  $element = getHeaderEventEntry();
  if (headerEvent && $element) $element.dispatchEvent(headerEvent);
};

export const getCloseAccountModal = (): any => {
  const closeModalEvent = createHeaderEvent('|close');
  const closeModal = () => handleHeaderEvents(closeModalEvent);

  return closeModal;
};

export const getOpenAccountModal = (
  payload: OpenModalPayload,
  shouldOpenRegistrationTab: boolean
): any => {
  const openModalEvent = createHeaderEvent('|open', payload);
  const openCreateAccountTab = createHeaderEvent(
    '|go-to-tab|create-account',
    payload
  );

  const openModal = () => handleHeaderEvents(openModalEvent);
  const navigateToCreateAccount = () =>
    handleHeaderEvents(openCreateAccountTab);

  const openAccountModal = () => {
    openModal();
    if (shouldOpenRegistrationTab) {
      navigateToCreateAccount();
    }
  };

  return openAccountModal;
};
